import React, { Component } from 'react';

class Home extends Component {
    render() {
        return (
            <div>
                <h1>Page not found - 404!</h1>
            </div>
        );
    }
}

export default Home;